import { routerForward, routerBackward } from '@constrant/Enum.js';

export default {
  data() {
    return {
      transitionName: '',
    };
  },

  methods: {
    initRouterAnimationListener() {
      service.Hookable.remove(routerForward, this.routerForward);
      service.Hookable.remove(routerBackward, this.routerBackward);

      service.Hookable.hook(routerForward, this.routerForward);
      service.Hookable.hook(routerBackward, this.routerBackward);
    },

    routerForward() {
      this.transitionName = 'slide-left';
    },

    routerBackward() {
      this.transitionName = 'slide-right';
    }
  },

  mounted() {
    this.initRouterAnimationListener();
  },
};

